module.exports = __webpack_public_path__ + "media/images/kumpass_logo-2c4f0ae1.jpg";